import { ArrowPathIcon } from '@heroicons/react/24/solid';
import { FC } from 'react';

export const LoadingSpinner: FC = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <ArrowPathIcon className="size-6 animate-spin text-blue-500" />
    </div>
  );
};
